import {ApplicationConfig, InjectionToken} from '@angular/core';
import {provideRouter} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {errorInterceptor} from './core/interceptors/error.interceptor';
import {loaderInterceptor} from './core/interceptors/loader.interceptor';

import {routes} from './app.routes';
import { environment } from '../environments/environment';
const IS_DEV_MODE = new InjectionToken<boolean>('IS_DEV_MODE');
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([loaderInterceptor, errorInterceptor])),    
    { provide: IS_DEV_MODE, useValue: !environment.production },
  ],
};
